import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-309eba4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "print-table" }

import { PrintTableColumn } from './types';
import { get } from 'lodash';

interface Props {
  columns: PrintTableColumn[],
  rows: Array<Record<string, any>>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PrintTable',
  props: {
    columns: null,
    rows: null
  },
  setup(__props: any) {



function getValue(row: Record<string, any>, column: PrintTableColumn) {
  if (typeof column.data === 'function') {
    return column.data(row);
  }
  return get(row, column.data);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, index) => {
          return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(column.title), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, index) => {
            return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(getValue(row, column)), 1))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})